import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Spinner, Layout } from "../../components";
import { Link } from "react-router-dom";
import { Categorys } from "../../categorys/categorys";
import { Users } from "../../users/users";
import {
  getArticlesByAuthor,
  getRecentArticles,
} from "../../services/articles.service";
import {
  makeStyles,
  FormControl,
  Paper,
  Table,
  TableCell,
  TableHead,
  TableRow,
  Select,
  InputLabel,
  MenuItem,
  TableBody,
  Grid,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    overflowX: "auto",
  },
  table: {
    minWidth: 650,
    transition: ".3s",
  },
}));

export const News = () => {
  const [loading, setLoading] = useState(true);
  const [articles, setArticles] = useState([]);
  const user = useSelector((store) => store.user);
  const [selectedUser, setSelectedUser] = useState(user.id);

  useEffect(() => {
    const getInitialArticles = async () => {

      try {
        if(user.isAdmin) {
          setArticles(await getRecentArticles())
        } else { 
          setArticles(await getArticlesByAuthor(user.id, 100))
        }
      } catch (error) {

        console.log("error get articles", error)

        setArticles([])
        

      } finally {
        setLoading(false);
      }
    };

    getInitialArticles();
  }, [user]);

  const handleUser = async ({ target }) => {

    setLoading(true);

    const [user] = Users.filter((opt) => opt.id === target.value);
    const articles = await getArticlesByAuthor(user.id, 100);

    setArticles(articles);
    setSelectedUser(user.id);
    setLoading(false);
  };

  const classes = useStyles();

  return (
    <Layout className="main">
      <Grid container>
        <Grid item md={10}>
          <h1>Notícias</h1>
        </Grid>
        {user.isAdmin && (
          <Grid item md={2} style={{ paddingTop: "12px" }}>
            <FormControl>
              <InputLabel id="user">Usuário</InputLabel>
              <Select
                value={selectedUser || ""}
                labelId="user"
                onChange={handleUser}
                style={{ minWidth: "150px" }}
              >
                {Users.map((opt, i) => (
                  <MenuItem key={i} value={opt.id}>
                    {opt.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        )}
      </Grid>
      <Paper className={classes.root}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="center">Acessos</TableCell>
              <TableCell>Título</TableCell>
              <TableCell align="center">Ordem</TableCell>
              <TableCell align="center">Categoria</TableCell>
              <TableCell align="center">Autor</TableCell>
              <TableCell align="center">Data</TableCell>
              <TableCell align="center">Publicado</TableCell>
              <TableCell align="center" />
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell>
                  <Spinner />
                </TableCell>
              </TableRow>
            ) : (
              articles?.length > 0 ? articles.map((article) => (
                <TableRow key={article.title}>
                  <TableCell align="center">{article.views || 0}</TableCell>
                  <TableCell component="th" scope="row">
                    <Link to={`/editar-artigo/${article.id}`}>
                      {article.title}
                    </Link>
                  </TableCell>
                  <TableCell align="center">{article.position || 0}</TableCell>
                  <TableCell align="center">
                    {Categorys.map((opt) =>
                      opt.id === article.category ? opt.title : null
                    )}
                  </TableCell>
                  <TableCell align="center">
                    {Users.map((opt) =>
                      opt.id === article.author ? opt.name.split(" ")[0] : null
                    )}
                  </TableCell>
                  <TableCell align="center">
                    {moment(article.createdAt).format("DD/MM")}
                  </TableCell>
                  <TableCell align="center">
                    {article.published ? (
                      <CheckIcon color="primary" />
                    ) : (
                      <CloseIcon color="secondary" />
                    )}
                  </TableCell>
                  <TableCell align="center">
                    {user.email === "luizfernandocad@gmail.com" && (
                      <DeleteIcon color="primary" />
                    )}
                  </TableCell>
                </TableRow>
              )) : (
                <TableRow>
                  <TableCell>Nenhum artigo para listar</TableCell>
                </TableRow>
              )
            )}
          </TableBody>
        </Table>
      </Paper>
    </Layout>
  );
};

export default News;
